// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const MicrophoneIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Microphone/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7 4a3 3 0 0 1 6 0v4a3 3 0 1 1-6 0V4Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11 14.93A7.001 7.001 0 0 0 17 8a1 1 0 1 0-2 0A5 5 0 0 1 5 8a1 1 0 1 0-2 0 7.001 7.001 0 0 0 6 6.93V17H6a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-3v-2.07Z"
}));
export default MicrophoneIcon;